import React from 'react';
import { FooterBranding } from 'components/FooterBranding/FooterBranding';
import { HeaderBranding } from 'components/HeaderBranding/HeaderBranding';
import { StyledContent, StyledLayout } from './Layout.styled';

const Layout: React.FC = ({ children }) => (
  <StyledLayout>
    <HeaderBranding role="banner" />
    <StyledContent role="main" id="main">
      {children}
    </StyledContent>
    <FooterBranding role="contentinfo" />
  </StyledLayout>
);

export default Layout;
